import type { SVGProps } from 'react';
const SvgViewColumn = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#view_column_svg__a)">
      <path
        fill="currentColor"
        d="M10 18h5V5h-5v13Zm-6 0h5V5H4v13ZM16 5v13h5V5h-5Z"
      />
    </g>
    <defs>
      <clipPath id="view_column_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgViewColumn;
